import { createFileRoute } from "@tanstack/react-router";
import AdminSetModulesPage from "@/pages/admin/sets/detail/modules";
import { useSetsPermissions } from "@/pages/admin/sets";

export const Route = createFileRoute("/app/admin/sets/$setId/modules/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { setId } = Route.useParams();
  const { userCanEditAllSets, userCanViewAllSets, userCanViewAllPrograms } = useSetsPermissions();

  return (
    <AdminSetModulesPage
      setId={Number(setId)}
      userCanEditAllSets={userCanEditAllSets}
      userCanViewAllSets={userCanViewAllSets}
      userCanViewAllPrograms={userCanViewAllPrograms}
    />
  );
}
